import React from 'react';
import { EmploymentContractCreate } from './index';

export const EmploymentContractDetail = () => (
  <EmploymentContractCreate readOnly />
);
